module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "setReps": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [(_vm.loading == true) ? _c('h2', {
    staticStyle: {
      "padding-top": "10%"
    }
  }, [_c('center', [_vm._v("Loading Reps"), _c('br'), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Please Wait")])])], 1) : _vm._e(), _vm._v(" "), (_vm.loading == false) ? _c('v-flex', {
    staticStyle: {
      "padding-left": "0px !important"
    },
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _c('br')], 1) : _vm._e(), _vm._v(" "), (_vm.loading == false) ? _c('v-data-table', {
    staticClass: "elevation-1 repLinkTable",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "search": _vm.search,
      "headers": _vm.headers,
      "items": _vm.responsibleReps,
      "hide-actions": "",
      "disable-initial-sort": "",
      "rows-per-page-items": [20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return (_vm.canShowRow(props.item.name)) ? [_c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_c('v-switch', {
          on: {
            "change": function($event) {
              return _vm.fncSaveResponsibleRep(props.item)
            }
          },
          model: {
            value: (props.item.checked),
            callback: function($$v) {
              _vm.$set(props.item, "checked", $$v)
            },
            expression: "props.item.checked"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "45%"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.fncExtractData(props.item.name, 0))
          }
        }), _vm._v(" "), _c('td', {
          attrs: {
            "width": "40%"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.fncExtractData(props.item.name, 1))
          }
        })] : undefined
      }
    }], null, true)
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-2 pt-2 buttonHolder",
    staticStyle: {
      "margin-top": "0px !important"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)])], 1)], 1)
},staticRenderFns: []}